import { useTranslation } from 'react-i18next'
import { ActionPopup } from 'components/Popup/ActionPopup'
import { SCREENS } from 'services/Analytics/Analytics'
import type { AiTileGeneratingCartItemWarning } from 'stores/cartStore/CartItem'
import { getTileWarningDisplay } from '../cartWarning.config'

export function AiTileGeneratingPopup({
  open,
  warning,
  onDismiss,
}: {
  open: boolean
  warning: AiTileGeneratingCartItemWarning
  onDismiss: () => void
}) {
  const { t } = useTranslation()
  const { labelKey } = getTileWarningDisplay(warning)

  return (
    <ActionPopup
      popupName="AI Tile Generating"
      open={open}
      imageComponent={null}
      showCloseButton
      onClose={onDismiss}
      mainText={t(labelKey)}
      secondaryText={t('order.ai_tile_generating_warning.popup_subtitle')}
      approveText={t('general.got_it')}
      onApproveTap={onDismiss}
      analyticsProps={{
        Source: SCREENS.CART_DRAWER,
        'Tile ID': warning.tileId,
      }}
      titleMaxWidth={300}
    />
  )
}
